import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";

const VideoSkeleton = () => {
  return (
    <Box sx={{ padding: "20px 0", backgroundColor: "#242743" }}>
      <Box
        sx={{
          display: "flex",
          gap: "20px",
          alignItems: "center",
          justifyContent: "start",
        }}
      >
        <Skeleton
          animation="wave"
          variant="circular"
          width={48}
          height={48}
          sx={{ marginLeft: "20px" }}
        />
        <Box>
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={50}
            height={10}
            sx={{ marginBottom: "10px" }}
          />

          <Skeleton
            animation="wave"
            variant="rectangular"
            width={100}
            height={10}
          />
        </Box>
      </Box>
      <Skeleton
        variant="rectangular"
        sx={{ height: "300px", marginTop: "10px" }}
        animation="wave"
      />
      <Box sx={{ padding: "10px 0 30px 20px" }}>
        <Skeleton
          variant="rectangular"
          width="40%"
          height={10}
          animation="wave"
          sx={{ marginTop: "20px" }}
        />
        <Skeleton
          variant="rectangular"
          width="60%"
          height={10}
          animation="wave"
          sx={{ marginTop: "10px" }}
        />
        <Skeleton
          variant="rectangular"
          width="20%"
          height={10}
          animation="wave"
          sx={{ marginTop: "10px" }}
        />
      </Box>
    </Box>
  );
};

export default VideoSkeleton;
